<template>
    <nav>
        <v-toolbar
            dark 
            color="purple"
            app
            fixed
            scroll-off-screen
            :scroll-threshold="scroll_treshold"
        >   
            <v-img 
                src='./logo.png'
                contain
                :height="45"
                :width="110"
                :max-height="60"
                :max-width="110"
                class="ml-2"
            ></v-img>
            <v-spacer></v-spacer>
            <!-- <v-layout justify-end v-if="isAdminUser"> -->
            <v-toolbar-items v-if="isAdminUser">
                <v-btn class="mx-1" flat router :to="{ name: 'adminPage' }">Dashboard</v-btn>
                <v-btn class="mx-1" flat router :to="{ name: 'adminReportingTool' }">Reports</v-btn>
            </v-toolbar-items>
            <!-- </v-layout> -->
            <v-btn flat class="text--white" style="pointer-events: none">Logged in as: {{this.activeUser.username}}</v-btn>
            <v-btn class="mx-1" @click="LogOut"><span class="bips">Log Out</span></v-btn>          
        </v-toolbar>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            drawer: true,
            scroll_treshold: 0,
            links: [
                { icon: 'dashboard', text: 'Dashboard', route: '/' },
                { icon: 'folder', text: 'Login', route: '/login' },              
            ]
        }
    },
    computed: {
        ...mapGetters([
            'activeUser',
            'isAdminUser',
        ]),
    },
    components: {},
    methods: {
        LogOut() {
            this.$store
                .dispatch('logout')
                .then(() => this.$router.push('/login'))
                .catch(err => console.log(err));
    }
    }
}
</script>

<style>
.toolbar-title {
  color: black;
  text-decoration: none;
}
</style>
